export default __webpack_public_path__ + "static/media/apple-touch-icon.6f34192d.png";